export default {
    init(Vue) {
        // 称呼/性别转换
        Vue.filter('appellation', function(data) {
            var obj = {}
            if (sessionStorage.getItem('Language') == '2') {
                obj = {
                    MR: '先生',
                    MRS: '太太',
                    MS: '女士',
                    DR: '',
                    NA: '不適用'
                }
            } else if (sessionStorage.getItem('Language') == '3') {
                obj = {
                    MR: '先生',
                    MRS: '太太',
                    MS: '女士',
                    DR: '',
                    NA: '不适用'
                }
            } else {
                obj = {
                    MR: 'Mr',
                    MRS: 'Mrs',
                    MS: 'Ms',
                    DR: '',
                    NA: 'N/A'
                }
            }
            if (data) {
                return obj[data]
            } else {
                return data
            }
        })

        // Identity type
        Vue.filter('idType', function(data) {
            var obj = {}
            if (sessionStorage.getItem('Language') == '2') {
                obj = {
                    HKID: '香港身份證',
                    PASSPORT: '護照',
                    TRAVEL: '旅遊證件',
                }
            } else if (sessionStorage.getItem('Language') == '3') {
                obj = {
                    HKID: '香港身份证',
                    PASSPORT: '护照',
                    TRAVEL: '旅游证件',
                }
            } else {
                obj = {
                    HKID: 'HKID',
                    PASSPORT: 'Passport',
                    TRAVEL: 'Travel document',
                }
            }
            if (data) {
                return obj[data]
            } else {
                return data
            }
        })

        // account type
        Vue.filter('accountType', function(data) {
            var obj = {}
            if (sessionStorage.getItem('Language') == '2') {
                obj = {
                    SOLE: '個人戶口',
                    JOINT: '聯名戶口',
                    COMPANY: '公司戶口',
                }
            } else if (sessionStorage.getItem('Language') == '3') {
                obj = {
                    SOLE: '个人户口',
                    JOINT: '联名户口',
                    COMPANY: '公司户口',
                }
            } else {
                obj = {
                    SOLE: 'Sole account',
                    JOINT: 'Joint account',
                    COMPANY: 'Company account',
                }
            }
            if (data) {
                return obj[data]
            } else {
                return data
            }
        })

        // disputed type 争议类型
        Vue.filter('disputedType', function(data) {
            var obj = {}
            if (sessionStorage.getItem('Language') == '2') {
                obj = {
                    TRANSACTION: '交易金額',
                    LOSS: '虧損',
                    INTEREST: '利息',
                    FEE: '費用	'
                }
            } else if (sessionStorage.getItem('Language') == '3') {
                obj = {
                    TRANSACTION: '交易金额',
                    LOSS: '亏损',
                    INTEREST: '利息',
                    FEE: '费用	'
                }
            } else {
                obj = {
                    TRANSACTION: 'Transaction amount',
                    LOSS: 'Loss',
                    INTEREST: 'Interest',
                    FEE: 'Fee	'
                }
            }
            if (data) {
                return obj[data]
            } else {
                return data
            }
        })

        // currency type 幣種
        Vue.filter('currencyType', function(data) {
            var obj = {}
            if (sessionStorage.getItem('Language') == '2') {
                obj = {
                    HKD: '港元(HKD)',
                    USD: '美元(USD)',
                    RMB: '人民幣(RMB)',
                    GBP: '英鎊(GBP)',
                    JPY: '日圓(JPY)',
                    EUR: '歐羅(EUR)',
                    CHF: '瑞士法郎(CHF)',
                    AUD: '澳元(AUD)',
                    CAD: '加拿大元(CAD)',
                    NZD: '紐西蘭元(NZD)',
                    THB: '泰珠(THB)',
                    SGD: '新加坡元(SGD)',
                    SEK: '瑞典克郎(SEK)',
                    DKK: '丹麥克郎(DKK)',
                    Others: '其他(Others)'
                }
            } else if (sessionStorage.getItem('Language') == '3') {
                obj = {
                    HKD: '港元(HKD)',
                    USD: '美元(USD)',
                    RMB: '人民币(RMB)',
                    GBP: '英镑(GBP)',
                    JPY: '日圆(JPY)',
                    EUR: '欧罗(EUR)',
                    CHF: '瑞士法郎(CHF)',
                    AUD: '澳元(AUD)',
                    CAD: '加拿大元(CAD)',
                    NZD: '纽西兰元(NZD)',
                    THB: '泰珠(THB)',
                    SGD: '新加坡元(SGD)',
                    SEK: '瑞典克郎(SEK)',
                    DKK: '丹麦克郎(DKK)',
                    Others: '其他(Others)'
                }
            } else {
                obj = {
                    HKD: 'HKD',
                    USD: 'USD',
                    RMB: 'RMB',
                    GBP: 'GBP',
                    JPY: 'JPY',
                    EUR: 'EUR',
                    CHF: 'CHF',
                    AUD: 'AUD',
                    CAD: 'CAD',
                    NZD: 'NZD',
                    THB: 'THB',
                    SGD: 'SGD',
                    SEK: 'SEK',
                    DKK: 'DKK',
                    Others: 'Others'
                }
            }
            if (data) {
                return obj[data]
            } else {
                return data
            }
        })

        // address type
        Vue.filter('methodType', function(data) {
            var obj = {}
            if (sessionStorage.getItem('Language') == '2') {
                obj = {
                    'POST': '透過郵寄',
                    'EMAIL': '透過電郵',
                    'BOTH': '透過郵寄和電郵',
                }
            } else if (sessionStorage.getItem('Language') == '3') {
                obj = {
                    'POST': '透过邮寄',
                    'EMAIL': '透过电邮',
                    'BOTH': '透过邮寄和电邮',
                }
            } else {
                obj = {
                    'POST': 'By post',
                    'EMAIL': 'By email',
                    'BOTH': 'By post and email',
                }
            }
            if (data) {
                return obj[data]
            } else {
                return data
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/util/filter.js